import dayjs from 'dayjs';
export const setCookie = (cname: string, cvalue: string, exdays: number) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d?.toUTCString()}`;
  // .bimg.shop 主域名
  document.cookie = `${cname}=${cvalue}; ${expires}; SameSite=None; Secure; Domain=${
    window.location.hostname === 'localhost'
      ? 'localhost'
      : `.${document.domain.split('.').splice(-2).join('.')}`
  }; Path=/`;
};

// 设置系统token
export const setToken = (data: TokenResult) => {
  const {
    userId,
    auth: { tokenType, token, refreshToken },
  } = data;

  // sessionStorage.setItem('tokenInfo', JSON.stringify({ userId, token: tokenType + token }));
  // localStorage.setItem('refreshToken', JSON.stringify({ userId, refreshToken: refreshToken }));
  sessionStorage.setItem('tokenInfo', JSON.stringify({ userId, token: token }));
  localStorage.setItem('refreshToken', JSON.stringify({ userId, refreshToken: refreshToken }));
  const cookieToken = getToken();
  setCookie('token', JSON.stringify(cookieToken), 1);
  // window.name = JSON.stringify(cookieToken);
};

export const getToken = () => {
  const refreshToken = JSON.parse(localStorage.getItem('refreshToken') || '{}');
  const tokenInfo = JSON.parse(sessionStorage.getItem('tokenInfo') || '{}');
  return {
    ...tokenInfo,
    ...refreshToken,
  } as TokenType;
};

export const getCookie = (cname: string) => {
  // 优先取 window.name
  // if (window.name) {
  //   return window.name;
  // }
  // 其次取token
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    const c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

// 清除所有缓存
export const storageClear = () => {
  // const temp = getLastLoginInfo() as { name: string; password: string };
  localStorage.clear();
  sessionStorage.clear();
  window.name = '';
  document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=None; Secure; Domain=${
    window.location.hostname === 'localhost'
      ? 'localhost'
      : `.${document.domain.split('.').splice(-2).join('.')}`
  }; Path=/`;
  // setLastLoginInfo(temp.name, temp.password);
};

export const getApiEnv = () => {
  const secondDomain = document.domain.split('.').shift();
  if (secondDomain?.includes('-')) {
    return '-' + secondDomain.split('-').pop();
  }

  return '';
};

// 获取API请求的主域
export const getDomain = () => {
  // 正式环境
  if (document.domain.includes('patternx.gemdale.com')) {
    return document.domain.split('.').splice(-3).join('.');
  }
  if (document.domain.includes('patternx.com')) {
    return document.domain.split('.').splice(-2).join('.');
  }
  // return 'patternx.gemdale.com';
  return document.domain.split('.').splice(1).join('.');
};

export const wrapperUrlWithPrefix = (url: string = '') => {
  if (!url) {
    throw new Error('url does not empty');
  }
  if (process.env.NODE_ENV === 'development') return url || '';
  if (url.startsWith('/boss')) {
    return `${window.origin}${url.substring(5)}`;
  }
  if (url.startsWith('/')) {
    const urlSplitArr = url.split('/');
    return `${window.location.protocol}//${
      urlSplitArr?.[1] + getApiEnv()
    }.api.${getDomain()}/${urlSplitArr.slice(2).join('/')}`;
  } else {
    throw new Error('url does not start with /');
  }
  // poatter demo: 'https://account-dev.api.bimg.shop';
};

export const setFromPath = () => {
  let fromPath = window.location.pathname;
  switch (window.location.pathname) {
    case '/platform/product/create/':
      fromPath = '/platform/product/list/approved';
      break;
    case '/platform/product/element-create/':
      fromPath = '/platform/product/element/approved';
      break;
    case '/platform/view/bim/':
      fromPath = '/platform/product/list/approved';
      break;
    case '/platform/view/bim/element/':
      fromPath = '/platform/product/element/approved';
      break;
    default:
  }
  sessionStorage.setItem('fromPath', fromPath);
};

// 获取登录环境地址
export const getPlatformLoginByEnv = () => {
  try {
    return `${window.location.protocol}//account${getApiEnv()}.${getDomain()}`;
  } catch (error) {
    console.log('获取登录环境地址出错啦');
  }

  // 默认跳转的路径
  return 'https://account-dev.patternx.gemdale.com';
};

// 不传name返回所有值，否则返回对应值
export function getQueryVariableInSKP(name: string = '', decodeType: string = 'decodeURI') {
  const decodeFn: any = {
    decodeURI: decodeURI,
    decodeURIComponent: decodeURIComponent,
  };
  const localurl = window.location.href;
  let url: any;

  if (localurl.indexOf('?') < 0) {
    return false;
  }

  url = localurl.split('?')[1];
  if (url.indexOf('&') > 0) {
    url = url.split('&');
  } else {
    url = [localurl.split('?')[1]];
  }
  let nameres;
  // 获取全部参数及其值
  for (let i = 0; i < url?.length; i++) {
    const info = url[i].split('=');
    const obj: any = {};
    obj[info[0]] = decodeFn[decodeType](info[1]);
    url[i] = obj;
  }
  // 如果传入一个参数名称，就匹配其值
  if (name) {
    for (let i = 0; i < url.length; i++) {
      for (const key in url[i]) {
        if (key === name) {
          nameres = url[i][key];
        }
      }
    }
  } else {
    nameres = url;
  }
  // 返回结果
  return nameres;
}

// export const goPlatformLogin = (others: any = {}) => {
//   // noRedirect: false 时，不需要重定向，目前 1,只有主动退出时，不需要重定向。 2: app.ts 中企业id检测。默认带重定向
//   if (others?.noRedirect) {
//     window.open(
//       `${
//         REACT_APP_ENV
//           ? 'http://localhost:8283/user/login/'
//           : `${getPlatformLoginByEnv()}/user/login/`
//       }`,
//       '_self',
//     );
//     return;
//   }
//   window.open(
//     `${replaceHost(REACT_APP_ORGANIZATION)}/user/login/?redirect_url=${
//       window.location.href
//     }&from=micro`,
//     `${
//       REACT_APP_ENV
//         ? `http://localhost:8283/user/login/?redirect_url=${encodeURIComponent(
//             window.location.href,
//           )}&from=boss`
//         : `${getPlatformLoginByEnv()}/user/login/?redirect_url=${encodeURIComponent(
//             window.location.href,
//           )}&from=boss`
//     }`,
//     '_self',
//   );
// };

export const goPlatformLogin = (others: any = {}) => {
  // noRedirect: false 时，不需要重定向，目前 1,只有主动退出时，不需要重定向。 2: app.ts 中企业id检测。默认带重定向
  // if (others?.noRedirect) {
  //   window.open(
  //     `${
  //       REACT_APP_ENV
  //         ? `http://localhost:8283/user/login/`
  //         : `${getPlatformLoginByEnv()}/user/login/`
  //     }`,
  //     '_self',
  //   );
  //   return;
  // }
  // 去掉token，refreshtoken
  const redirectUrl = window.location.href;
  const params = getQueryVariableInSKP() || [];
  const targetParams = params?.filter(
    (i: any) => Object.keys(i)[0] !== 'token' && Object.keys(i)[0] !== 'refreshToken',
  );
  let url = redirectUrl.split('?')[0];
  const allParams: any = [];
  targetParams.forEach((i: any) => {
    const key = Object.keys(i)[0];
    allParams.push(`${key}=${i[key]}`);
  });
  if (allParams.length > 0) {
    url = `${url}?${allParams.join('&')}`;
  }
  // console.log(window.location.hostname, '====window.location.hostname');
  // console.log(
  //   `${
  //     window.location.hostname === 'localhost'
  //       ? `http://localhost:5100/login/?redirect_url=${encodeURIComponent(url)}&from=boss`
  //       : `${getPlatformLoginByEnv()}/user/login/?redirect_url=${encodeURIComponent(url)}&from=boss`
  //   }`,
  // );
  window.open(
    `${
      window.location.hostname === 'localhost'
        ? `http://localhost:5100/login/?redirect_url=${encodeURIComponent(url)}&from=boss`
        : `${getPlatformLoginByEnv()}/login?redirect_url=${encodeURIComponent(url)}&from=boss`
    }`,
    '_self',
  );
};

export const replaceHost = (host: string) => {
  const env = window.location.host.split('.')[0].split('-')[1];
  return host.replace(/JDENV/, env);
};

export const getStatus: (n: number) => string = (n: number) => {
  let str = '';
  switch (n) {
    case 0: {
      str = '待处理';
      break;
    }
    case 1: {
      str = '完成';
      break;
    }
    case 2: {
      str = '失败';
      break;
    }
    case 3: {
      str = '转化过,不重新转换';
      break;
    }
    case 4: {
      str = '转换中';
      break;
    }
    case 5: {
      str = '取消转换';
      break;
    }
    default: {
      break;
    }
  }
  return str;
};

export const getRenderStatus: (n: number) => string = (n: number) => {
  let str = '';
  switch (n) {
    case 0: {
      str = '新建';
      break;
    }
    case 1: {
      str = '排队中';
      break;
    }
    case 2: {
      str = '渲染中';
      break;
    }
    case 3: {
      str = '完成';
      break;
    }
    case 4: {
      str = '失败';
      break;
    }
    case 5: {
      str = '取消';
      break;
    }
    default: {
      str = '错误';
      break;
    }
  }
  return str;
};

export const getDurationTime: (startTime: string | number, endTime: string | number) => string = (
  startTime: string | number,
  endTime: string | number,
) => {
  if (!startTime || !endTime) {
    return '/';
  } else {
    if (dayjs(endTime).diff(startTime, 'minute') < 1) {
      return `${dayjs(endTime).diff(startTime, 'second')}s`;
    } else {
      return `${dayjs(endTime).diff(startTime, 'minute')}min`;
    }
  }
};

export const formatTime: (time: string | number) => string = (time: string | number) => {
  if (!time) {
    return '/';
  } else {
    return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
  }
};

export const getQueryVariable = (str: string) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === str) {
      return pair[1];
    }
  }
  return false;
};

export const getEnterpriseId = (): string => {
  return getQueryVariable('enterpriseId') || sessionStorage.getItem('enterpriseId') || '';
};

/**
 * 包装list为树结构
 * @param data
 * @param keyName
 */
export function toTree<T extends ITreeField>(
  data: T[],
  keyName = {
    id: 'id',
    parentId: 'parentId',
  },
  convert?: (item: T) => any,
): ITreeField[] {
  const result: T[] = [];
  if (!Array.isArray(data)) {
    return result;
  }
  const map: any = {};
  data.forEach((item: T) => {
    item.children = [];
    item.key = item[keyName.id];
    map[item[keyName.id]] = item;
    convert?.(item);
  });
  data.forEach((item) => {
    const parent: T = map[item[keyName.parentId]];
    if (parent) {
      (parent.children || (parent.children = [])).push(item);
    } else {
      result.push(item);
    }
  });
  return result;
}

export const getUUIDByLength = (len: number) => {
  const source = new Array(len).fill('x');
  const sourceStr = source.join('');
  return sourceStr.replace(/[x]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const formatStr: (val: string, n?: number) => string = (
  val: string,
  n: number = 2,
): string => {
  if (val.length > n) {
    return val.slice(0, n) + '...';
  } else {
    return val;
  }
};

/**
 * 获取uuid
 */
export const getUUID = () => {
  return (
    (Math.random() * 10000000).toString(16).substr(0, 4) +
    new Date().getTime() +
    Math.random().toString().substr(2, 5)
  );
};

/**
 * 文件大小转换
 * @param limit    文件大小 B
 * @param unitSize 单位大小，例如：小于{unitSize}KB的就显示M
 * @returns
 */
export const formaFileSize = (
  limit: number = 0,
  unitSize: number = 0.1,
  connectCharacter?: string,
) => {
  let size = '';
  const finallyConnectCharacter = connectCharacter ?? ' ';
  if (!limit) return '/';
  if (limit < unitSize * 1024) {
    //小于0.1KB，则转化成B
    size = limit.toFixed(1) + finallyConnectCharacter + 'B';
  } else if (limit < unitSize * 1024 * 1024) {
    //小于0.1MB，则转化成KB
    size = (limit / 1024).toFixed(1) + finallyConnectCharacter + 'KB';
  } else if (limit < unitSize * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB
    size = (limit / (1024 * 1024)).toFixed(1) + finallyConnectCharacter + 'MB';
  } else {
    //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(1) + finallyConnectCharacter + 'GB';
  }

  const sizeStr = size + ''; //转成字符串
  const index = sizeStr.indexOf('.'); //获取小数点处的索引
  const dou = sizeStr.substr(index + 1, 1); //获取小数点后两位的值
  if (dou == '0') {
    //判断后两位是否为0，如果是则删除0
    // eg : sizeStr = "29.0 GB"
    // 那么 index = 2,
    // 那么 要删除的就是小数点和0，所以就从小数点开始+2，也就是index+2 ，后面是一个连接字符（finallyConnectCharacter）的长度 + 单位的长度（B是一位，其它是两位，取最大值为3
    //这就是 sizeStr.substr(index + 2, 3);
    return (
      sizeStr.substring(0, index) + sizeStr.substr(index + 2, finallyConnectCharacter.length + 2)
    );
  }
  return size;
};

/**
 * 请求失败
 * @param res
 */
export const isRequestError = (res: { code?: string }) => {
  return res?.code && res?.code.toLowerCase() !== 'success';
};

export const downLoadFile = (url: string, fileName: string) => {
  const aTag = document.createElement('a');
  aTag.href = url;
  aTag.download = fileName; // 如果url为网络地址时，download属性不生效？
  document.body.appendChild(aTag);
  aTag.click();
  document.body.removeChild(aTag);
};

export const downLoadFileByBlob = (blob: Blob, name: string = '批量打包.zip') => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([blob]));
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
